import CoreAPIService from '../../../utils/core-api';
import { editDocumentData } from '../shared/document-utils';
import { fetchAction } from '../../actions';
import { types as companyTypes } from '../companies';
import { types as partnerTypes } from '../partners';
import { types as driverTypes } from '../drivers';
import { types as vehicleTypes } from '../vehicles';
import ObjectUtils from '../../../utils/objectUtils';
import envConfig from '../../../config';
import { name, types } from './actionTypes';
import { DocumentState, DocumentById } from './types';

// Listes blanches pour les documents qui utilisent privapi et docnsign
// pour la gestion des document
const PRIVAPI_DOC_TYPES = ['contract'];
const PRIVAPI_DOC_CLASSES = ['partner'];

const shouldUsePrivapi = (docType: string, docClass: string): boolean => {
    return PRIVAPI_DOC_TYPES.includes(docType) && PRIVAPI_DOC_CLASSES.includes(docClass);
};

export const actions = {
    // `type` is the document type: it tags a failure so the card that fired it can show it
    sendSMS: (id, idPartner, idSignatories, type?) =>
        fetchAction(CoreAPIService.put(`/core/partners/${idPartner}/contract`, {}), types.SEND_SMS, {
            id,
            idSignatories,
            type,
        }),
    getDocumentVersion: (id, idVersion) =>
        fetchAction(CoreAPIService.get(`/core/documents/version/${idVersion}`), types.GET_DOC_VERSION, { id }),
    updateDocVersion: (id, payload, type?) =>
        fetchAction(CoreAPIService.put(`/core/documents/${id}/version`, payload), types.UPDATE_DOC_VERSION, {
            id,
            type,
        }),
    upsertDoc: (type, payload) =>
        fetchAction(CoreAPIService.post(`/core/documents/upsert`, payload), types.UPSERT_DOC, { type }),
    activatePartnerEmailContract: (partnerId) =>
        fetchAction(
            CoreAPIService.post(
                `/internal/partner/activate-email-contract`,
                { partnerId },
                null,
                envConfig.privapi_url,
            ),
            types.ACTIVATE_PARTNER_EMAIL_CONTRACT,
            { partnerId },
        ),
    activateDocumentVersion: (documentId, versionId, docType, docClass, classId) => {
        if (shouldUsePrivapi(docType, docClass)) {
            return actions.activatePartnerEmailContract(classId.toString());
        } else {
            return actions.getDocumentVersion(documentId, versionId);
        }
    },
};

//======================================//
//=============== Method ===============//
//======================================//

const initialState: DocumentState = {
    documents: {} as DocumentById,
};

const reducer = (state = initialState, action): DocumentState => {
    const payload = action.payload;
    const parameters = action.parameters;
    const id = parameters ? parameters.id : 0;
    const idSignatories = parameters ? parameters.idSignatories : 0;
    switch (action.type) {
        case partnerTypes.GET_PARTNER:
        case partnerTypes.EDIT_PARTNER:
        case driverTypes.GET_DRIVER:
        case vehicleTypes.GET_VEHICLE:
        case companyTypes.GET_COMPANY:
            return editDocumentData(state, action);

        case types.SEND_SMS:
            const newState = ObjectUtils.deepCopy(state);
            newState.documents[id].current_version.signatories[idSignatories].sms_status = 'sent';
            return newState;
        case types.GET_DOC_VERSION:
            return {
                ...state,
                documents: {
                    ...state.documents,
                    [id]: {
                        ...state.documents[id],
                        current_version: payload,
                    },
                },
            };
        case types.UPDATE_DOC_VERSION:
            return {
                ...state,
                documents: { ...state.documents, [id]: payload },
            };
        case types.UPSERT_DOC:
            return {
                ...state,
                documents: { ...state.documents, [payload.id]: payload },
            };

        case types.ACTIVATE_PARTNER_EMAIL_CONTRACT:
        case partnerTypes.REGENERATE_PARTNERSHIP_CONTRACT:
            return {
                ...state,
                documents: {
                    ...state.documents,
                    [payload.data.id]: {
                        ...payload.data,
                    },
                },
            };
        case partnerTypes.SAVE_PARTNERSHIP_CONTRACT:
        case partnerTypes.REGENERATE_PARTNERSHIP_CONTRACT:
            return {
                ...state,
                documents: { ...state.documents, [payload.id]: payload },
            };
        default:
            return state;
    }
};
export default reducer;

const localState = (state: any): DocumentState => state[name] || initialState;
export const selectors = {
    documents: (state) => localState(state).documents,
};
